import BaseService from "./BaseService";
import { TagRequest, TagResponse, TagsResponse, PaginatedTagsResponse } from "./mappers/TagMapper";
import store from "@/store";

class TagService extends BaseService {
  constructor() {
    super();
  }

  createCompanyTag(id, data) {
    store.dispatch("app/setTags", null);
    return this.post(`companies/${id}/tags/`, TagRequest(data))
      .then((response) => response.data)
      .then((data) => TagResponse(data));
  }

  getTagsByCompany(id, page = 1, pageSize = 200, search = "") {
    let modifiedData;
    if(page == 1 && pageSize == 200 && search == "" && (store.getters["app/tags"] != null))  //default is 50 when fetching
    {
      return Promise.resolve(store.getters["app/tags"]);
    }

    return this.get(`companies/${id}/tags/?page=${page}&page_size=${pageSize}&search=${search}`)
      .then((response) => {
        modifiedData = PaginatedTagsResponse(response.data);
        store.dispatch("app/setTags", modifiedData);
        return modifiedData;
      })
      .then(() => modifiedData);
  }

  // getTagsByCompanyIncludingSystem(id) {
  //   return this.get(`companies/${id}/tags/all/`)
  //     .then((response) => response.data)
  //     .then((data) => TagsResponse(data));
  // }

  getTag(id) {
    return this.get(`tags/${id}/`)
      .then((response) => response.data)
      .then((data) => TagResponse(data));
  }

  updateTag(id, data) {
    store.dispatch("app/setTags", null);
    return this.patch(`tags/${id}/`, TagRequest(data))
      .then((response) => response.data)
      .then((data) => TagResponse(data));
  }

  deleteTag(id) {
    store.dispatch("app/setTags", null);
    return this.delete(`tags/${id}/`);
  }

  getEsrsTags() {

    if(store.getters["app/esrstags"] != null)
    {
      return Promise.resolve(store.getters["app/esrstags"]);
    }
    return this.get(`esrstags`)
      .then((response) => {
        store.dispatch("app/setEsrsTags", response.data);
        return response.data;
      })
  }
}

export default new TagService();
